import React from "react";

const FourOhFour = (): JSX.Element => {
  return (
    <div className="content">
      <h1>Error 404 &mdash; Not found.</h1>
      <p>The page you're trying to access does not exist on this server.</p>
    </div>
  );
};

export default FourOhFour;
